


export enum RubricStatus {
	DISABLE = "DISABLE",
	ENABLE = "ENABLE"
};


